import React from "react"
import * as S from "./ImageCarouselItem.styled"
import Img from "gatsby-image/withIEPolyfill"

export default ({
  img,
  imgAlt,
  fluid,
  reference,
  children,
  objectFit = "cover",
  animateImageOnHover = false,
  ...props
}) => (
  <S.Item
    ref={reference}
    animateImageOnHover={animateImageOnHover}
    setMinWidth={!img && !fluid}
    {...props}
  >
    {img && <S.Background alt={imgAlt} src={img} />}
    {fluid && (
      <S.FluidContainer className="fluid-container">
        <Img fluid={fluid} objectFit={objectFit} style={{ height: "100%" }} />
      </S.FluidContainer>
    )}
    {children && <S.ContentContainer>{children}</S.ContentContainer>}
  </S.Item>
)
